import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/feedback/Dialog';
import { IconAppQr } from '../ui/icon/IconAppQr';
import { IconDownloadFomStores } from '../ui/icon/IconDownloadFromStores';
import { Box } from '../ui/layout/Box';
import { Typography } from '../ui/typography/Typography';
import { useBackButton } from '../utils/useBackButton';
import { useTranslation } from '../utils/useTranslation';

export function AppsQrDialog() {
    const t = useTranslation();
    const onNavigateBack = useBackButton();

    return (
        <Dialog onClose={onNavigateBack}>
            <DialogContent>
                <DialogTitle onClose={onNavigateBack} withBorderBottom={false} />
                <IconAppQr fontSize={350} style={{ margin: 'auto' }} color="var(--color-primary)" />
                <Typography
                    variant="body"
                    color="var(--color-primary)"
                    weight="bold"
                    m="auto"
                    width="80%"
                    textAlign="center"
                >
                    {t('Отсканируйте QR-код, чтобы скачать мобильное приложение')}
                </Typography>
                <Box m="auto" pt={2}>
                    <IconDownloadFomStores height="40px" width="405px" fontSize="500px" />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
